import { forwardRef, Ref } from "react";
import {
  SearchFieldProps,
  SearchField,
} from "../../../components/SearchField/internal/SearchField";

import { useToolbarSize } from "./internal/ToolbarContext";

import cx from "classnames";
import styles from "./ToolbarSearchField.module.scss";

/**
 * Props for the ToolbarSearchField component
 *
 * @extends Omit<SearchFieldProps, "size">
 */
export type ToolbarSearchFieldProps = Omit<SearchFieldProps, "size">;

/**
 * ToolbarSearchField component renders a search field for use in toolbars.
 *
 * Features:
 * - Renders a search field styled for toolbar usage
 * - Supports all SearchField props except size
 * - Integrates with toolbar layouts and accessibility
 *
 * @example
 * <ToolbarSearchField placeholder="Search..." />
 */
export const ToolbarSearchField = forwardRef(
  (props: ToolbarSearchFieldProps, ref: Ref<HTMLInputElement>) => {
    const { className, ...rest } = props;
    const size = useToolbarSize();

    const searchFieldStyles = cx(styles["toolbar-search-field"], className);

    return (
      <div className={styles["toolbar-search-field-container"]}>
        <SearchField
          ref={ref}
          className={searchFieldStyles}
          size={size}
          data-anv="toolbar-search-field"
          {...rest}
        />
      </div>
    );
  },
);

ToolbarSearchField.displayName = "ToolbarSearchField";
